declare const wc_bookings: any;

interface WcBookingsDate {
    date_picker: { value: string };
}

/**
 * Adds month and year picker to datepicker.
 * Adds support for remembering current year and month.
 */
jQuery(function($) {
    wc_bookings.hooks.addAction("wc_bookings_date_picker_refreshed", "dhp", function() {
        $(".picker").datepicker("option", {
            changeMonth: true,
            changeYear: true
        });
        
        if (localStorage.getItem("dhpSelectedDate")) {
            $(".picker").datepicker("setDate", localStorage.getItem("dhpSelectedDate"));
        }
    });

    wc_bookings.hooks.addAction("wc_bookings_date_selected", "dhp", function(selectedDate: WcBookingsDate) {
        localStorage.setItem("dhpSelectedDate", selectedDate.date_picker.value);
    });
});

/** Add explanatory text to bookings */
jQuery(function($) {
    $("#wc-bookings-booking-form .wc-bookings-date-picker")
        .after('<em style="font-size: 0.8em;"><em style="color: green;">Grønn</em>=ledig, <em style="color: orange;">oransje</em>=delvis ledig, <em style="color: red;">rød</em>=fullbooket</em>');
});

/**
 * Book now button functionality.
 */

jQuery(function($) {
    $(".button-book-now").click(function() {
        $("form.cart").attr("action", "?book_now=true");
        $("form.cart").submit();
    });
});

const params = new URLSearchParams(window.location.search);
if (params.get("book_now") === "true") {
    location.href = "/kasse";
}
